import { Typography } from '@mui/material';
import { AdvancedMarker, APIProvider, Map } from '@vis.gl/react-google-maps';

import {
  MapMetric,
  PoleWithPosition,
} from '../../../../../../../../api/theHive/redeProto/types';
import {
  BRAZIL_CENTER,
  GOOGLE_MAP_ID,
} from '../../../../../../../../constants/redeProto';
import { metricColor } from '../../mapMetrics';
import { Dot, MapFrame, Placeholder } from './styles';

interface MapCanvasProps {
  poles: PoleWithPosition[];
  metric: MapMetric;
  selectedPole: PoleWithPosition | undefined;
  onSelect: (pole: PoleWithPosition) => void;
}

export function MapCanvas({
  poles,
  metric,
  selectedPole,
  onSelect,
}: MapCanvasProps): JSX.Element {
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

  if (!apiKey) {
    return (
      <Placeholder>
        <Typography sx={{ fontWeight: 600 }}>Mapa indisponível</Typography>
        <Typography sx={{ fontSize: '13px' }}>
          Configure a variável REACT_APP_GOOGLE_MAPS_API_KEY para visualizar o
          mapa. A lista de polos ao lado continua funcional.
        </Typography>
      </Placeholder>
    );
  }

  return (
    <MapFrame>
      <APIProvider apiKey={apiKey} libraries={['marker']}>
        <Map
          mapId={GOOGLE_MAP_ID}
          className="rede-proto-map"
          defaultCenter={BRAZIL_CENTER}
          defaultZoom={4}
          minZoom={3}
          streetViewControl={false}
          mapTypeControl={false}
        >
          {poles.map((pole) => (
            <AdvancedMarker
              key={pole.poleId}
              position={pole.position}
              onClick={() => onSelect(pole)}
            >
              <Dot
                color={metricColor(pole, metric)}
                selected={selectedPole?.poleId === pole.poleId}
              />
            </AdvancedMarker>
          ))}
        </Map>
      </APIProvider>
    </MapFrame>
  );
}
